import styled from 'styled-components';

export const ContextualNodeHeader = styled.div`
  display: flex;
  align-items: center;
  margin-top: 1.25rem;
  margin-bottom: 0.9375rem;
`;

export const ContextualNodeTitle = styled.div`
  font-weight: bold;
  font-size: 1rem;
  margin-right: 0.625rem;
`;

export const ContextualNodeContainer = styled.div`
  margin-bottom: 1.25rem;
  max-width: 56rem;
`;

export const ContextualNodeRow = styled.div`
  display: flex;
  gap: 1.25rem;
  flex-wrap: wrap;
  position: relative;
`;

export const RemoveButtonContainer = styled.div`
  position: absolute;
  top: 1.28rem;
  right: -2.625rem;
  z-index: 1;
`;

export const FieldContainer = styled.div`
  flex: 1;
  min-width: 12.5rem;
`;

export const FieldLabel = styled.div`
  margin-bottom: 0.5rem;
  font-size: 0.7rem;
  font-weight: 500;
`;

export const FieldInfoText = styled.div`
  margin-top: 0;
  font-size: 0.7rem;
  color: ${({ theme }) => theme.color.gray[1000]};
`;
